<div class="banners-container flex flex-column justify-center items-center">
  @for (banner of toastBanners(); track banner) {
    <div>
      <div class="action-msg">
        <span class="action-content">{{ banner.message }}</span>
        <span class="action-content">
          @if (banner.buttonText) {
            <button id="btnToastAction" mat-button (click)="onActionClick(banner)">
              {{ banner.buttonText }}
            </button>
          }
        </span>
      </div>
    </div>
  }
</div>
